import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {computed, observable} from 'mobx';
import {FormattedMessage, injectIntl} from 'react-intl';
import Select from 'react-select';
import {instruments, instrumentsForUsers} from '../../constants/constants';
import {getUserMainInstrument, isAdmin} from '../../utils/userUtility';
import './styles.scss';

@injectIntl
@observer
class SelectInstrument extends Component {
    @observable instruments = [];

    componentWillMount() {
        const {intl: {formatMessage: translate}} = this.props;
        this.instruments = (isAdmin() ? instruments : instrumentsForUsers).map((instrument) => {
            return {
                value: instrument.name,
                label: translate({id: `upload.form.instruments.${instrument.name}`})
            };
        });
    }

    @computed get activeInstrument() {
        return this.instruments.find(i => i.value === this.props.instrument.value);
    }

    @computed get defaultInstrument() {
        return this.instruments.find(i => i.value === getUserMainInstrument());
    }

    render() {
        const {showLabel = true, intl: {formatMessage: translate}, label} = this.props;
        return (
            <div className="select-instrument-container">
                {showLabel && <label htmlFor="instrumentSelect" className="instrument-label">
                    {label || <FormattedMessage id="profile.instrument"/>}
                </label>}
                <Select
                    inputId="instrumentSelect"
                    classNamePrefix="form"
                    className="form-select-container"
                    value={this.activeInstrument}
                    defaultValue={this.defaultInstrument}
                    onChange={this.props.onChange}
                    options={this.instruments}
                    placeholder={translate({id: 'general.mainInstrument'})}
                />
            </div>
        );
    }
}

SelectInstrument.propTypes = {
    instrument: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
};

export default SelectInstrument;
